import React from 'react';

import Card from 'components/Card';
import IconDisc from 'components/IconDisc';
import Stack from 'components/Stack';
import Text from 'components/Text';

const LandmarkLink = ({icon, title, headingLevel = 'h3', button, children}) => {
	return (
		<Card maxWidth={440} mx="auto" textAlign="center" p="m">
			<Stack spacing="s">
				{icon && <IconDisc shady size="big" name={icon} />}
				<>
					{title && (
						<Text bold as={headingLevel}>
							{title}
						</Text>
					)}
					{children}
				</>
				{button}
			</Stack>
		</Card>
	);
};

export default LandmarkLink;
